/** 节点来源对应的徽标颜色：前端、后端、模型、TTS 在图和表里用同一套。 */
export function sourceVariant(source) {
  switch (source) {
    case 'client':
      return 'success'
    case 'server':
      return 'neutral'
    case 'model':
      return 'info'
    case 'tts':
      return 'warning'
    default:
      throw new Error(`Unhandled turn timeline node source: ${source}`)
  }
}
